import { environment } from './../../../environments/environment';
import {Component, OnInit, ViewChild} from '@angular/core';
import {UserVO} from '../../model/UserVO';
import {UserService} from '../../service/UserService';
import {Router} from '@angular/router';
import { CoachingService } from '../../service/coaching.service';
import { HttpClient } from '@angular/common/http';
import { IS_PORTUGAL } from '../../helpers/GlobalConstants';
import { RoleService } from '../../service/RoleService';
import { LoggerService } from '../../service/LoggerService';
import { OpenFicheService } from '../../service/open-fiche.service';
import { ObjectNotificationService } from '../../service/obj-notification.service';
import { BlockService } from '../../service/BlockService';
import {DelegationService} from '../../modules/delegation/delegation.service';
import {AuthService} from '../../auth/services/auth.service';
import {FeatureAccessService} from '../../service/feature-access.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  public icon_menu_toggleCheck = 'check_box';
  standard = localStorage.getItem('standard');
  public collaborator: UserVO = null;
  public environment: string = environment.api.oldBlocktemps;
  isPorgugal  = localStorage.getItem(IS_PORTUGAL) == 'Y';
  objNotificationService$ = this.objNotificationService.observer$;
  REPORTING_ALLOWED_ACCESS : string[] = ["QUALITY CONTROLLER","QUALITY MONITORING TEAM LEADER"]

  private has_saisie_coach = null;
  currentOps:any;

  totalDelegationsExpiring:number;
  currentBUMs:any;
  isValidOps = false;
  isValidBUMs = false;
  otherOps = false;
  otherBUMs = false;
  isMaurice = false;
  panelOpenState: boolean = false;
  isOps = false;
  isBUM = false;
  isDS = false;
  badge: any;

  countryCode: string ="";
  @ViewChild('teamsoption') public teamsoption: any;
  hrbpNotifs: number;
  hficheUnlockingNotifs: number;

  constructor(private coachingService: CoachingService,
              private user: UserService,
              public router: Router,
              private roleService: RoleService,
              private LOG: LoggerService,
              public featureAccessService: FeatureAccessService,
              private delegationService: DelegationService,
              private http: HttpClient,
              private openFicheService: OpenFicheService, public authService: AuthService,

              private objNotificationService: ObjectNotificationService) {
  }

  ngOnInit() {
      /* Get Country user connected */
    this.countryCode = this.user.getUserCountry();
    this.collaborator = this.user.getUser();
    this.totalDelegationsExpiringSoon(this.collaborator.avatar);
    const avatar = this.collaborator && this.collaborator.userName;
    this.currentOps = environment.verroFiche.onlyOps;
    this.isMaurice = avatar && avatar.startsWith('R');
    this.currentBUMs = environment.verroFiche.onlyBUMs;
    this.isValidOps = this.currentOps && this.currentOps.indexOf(avatar) > -1;
    this.isValidBUMs = this.currentBUMs && this.currentBUMs.indexOf(avatar) > -1;
    this.isBUM = this.roleService.isBUM;
    this.isOps = this.roleService.isOps;
    this.isDS = this.roleService.isDS;
    this.otherOps = this.isOps && !this.isValidOps;
    this.otherBUMs = this.isBUM && !this.isValidBUMs;
    const roles = this.roleService.getConnectedUserRole();
      // console.log(roles);
    this.LOG.info(`${roles && roles.length > 0 ? 'Connected user myShift roles : ' + roles: 'No roles assigned to Myshift'}`);
    this.validationVerroRequestNotif() && this.validationVerroRequestNotif().subscribe(res => {
      this.badge = res;
    })
    this.getHRBPnotifs();
    this.objNotificationService$.subscribe((obj: any) => {
      this.LOG.info(`HRBP notification updates = ${obj.hrbpNotificationUpdate}`);
      obj.hrbpNotificationUpdate ? this.getHRBPnotifs() : '';},
        error => this.LOG.warn(error), () => this.objNotificationService.clearMessages())
  }


  getHRBPnotifs(){
    this.openFicheService.getHRBPnotifs().subscribe(result => {
      this.hrbpNotifs = result.count;
      this.objNotificationService.clearMessages();
    })
/*    this.authService.getHRBPUnlockNotifs().subscribe(result => {
      this.hficheUnlockingNotifs = result.count;
      this.objNotificationService.clearMessages();
    })*/
  }

  totalUnlockPending(){
    return this.authService.totalUnlock;
  }

  validationVerroRequestNotif() {
    if (this.roleService.isOps) return this.http.get(`${environment.api.blocktemps}/verro/notif/${BlockService.SEARCH_VERRO_TL_URL}`);
    if (this.roleService.isBUM) return this.http.get(`${environment.api.blocktemps}/verro/notif/${BlockService.SEARCH_VERRO_OPS_URL}`);
    if (this.roleService.isDS) return this.http.get(`${environment.api.blocktemps}/verro/notif/${BlockService.SEARCH_VERRO_BUM_URL}`);
    return null;
  }

  public Event(key, action, callback?) {
    if ( Object.keys(environment).indexOf(key) > -1 ) {
      if (typeof callback === 'function') { callback(); }
      window.location.href = environment[key][action];
    }
  }
  public Logout() {
    this.Event('oauth', 'logOut', () => {
      window.localStorage.clear();
      sessionStorage.clear();
    });
  }

  hasSaisieCoach() {
    if (this.has_saisie_coach === null) {
      this.has_saisie_coach = this.coachingService.hasSaisieCoach();
    }
    return this.has_saisie_coach;
  }

  hasInjectionPermission () {
    return environment.exceptionUserInjectRealise.includes(this.user.getCurrentUser('userName')) &&
      (this.user.getUser().role === 'TL' || this.user.getUser().role === 'OPS');
  }


  private totalDelegationsExpiringSoon(matricule: string) {
    this.delegationService.totalDelegationsExpiringSoon(matricule)
      .subscribe(total=> this.totalDelegationsExpiring = total)
  }


  // Check that TL type is PROD or Hors PROD
  checkTlIsProd(){
    return this.authService.checkTlIsProd();
  }

  checkCountryAllowedForUnlocking(){
    return this.user.checkIfCountryAuthorizedForUnlocking(true) && !this.isHorsProd();
  }

  isHorsProd() {
    return this.user.isHorsProdMyShift();
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/sidebar.component.ts